// document.addEventListener('DOMContentLoaded', (event) => {
//   debugger;
//   // var check = sessionStorage.getItem("country");
//    // var country = geoplugin_countryCode();
//    var check = sessionStorage.getItem("country");
//   if (check != undefined && check != null && check != "") {
//     showCountryDiv(check);
//     console.log(sessionStorage.getItem("country"));
//   } else {
//     $.get("https://ipinfo.io/json", function (response) {
//       var country = response.country;
//       sessionStorage.setItem("country", response.country);
//       showCountryDiv(country);
//       console.log(sessionStorage.getItem("country"));
//     }, "jsonp");
//   }
// });

// function showCountryDiv(country) {
//   if (country == 'PK') {
//     $('.product__icon__text.spain').show();
//      $('.product__block.shipping_date').show();
//     $('.product__icon__text.france').hide();
//     $('.product__icon__text.denmark').hide();
//     $('.product__icon__text.italy').hide();
//       function calculateShippingDates() {
//   const today = new Date();
//   const firstDate = new Date(today.getTime() + 24 * 60 * 60 * 1000); // add 1 day
//   const secondDate = new Date(today.getTime() + 5 * 24 * 60 * 60 * 1000); // add 5 days
//   // handle Sunday and Saturday
//   if (firstDate.getDay() === 0) {
//     firstDate.setDate(firstDate.getDate() + 1);
//   } else if (firstDate.getDay() === 6) {
//     firstDate.setDate(firstDate.getDate() + 2);
//   }
//   if (secondDate.getDay() === 0) {
//     secondDate.setDate(secondDate.getDate() + 1);
//   } else if (secondDate.getDay() === 6) {
//     secondDate.setDate(secondDate.getDate() + 2);
//   }
//   // format dates as "dd/mm"
//   const firstDateString = `${firstDate.getDate().toString().padStart(2, '0')}/${(firstDate.getMonth() + 1).toString().padStart(2, '0')}`;
//   const secondDateString = `${secondDate.getDate().toString().padStart(2, '0')}/${(secondDate.getMonth() + 1).toString().padStart(2, '0')}`;
//   return `${firstDateString} to ${secondDateString}`;
// }
// setInterval(() => {
//   const shippingDates = calculateShippingDates();
//   $('.spain .today_date').html(shippingDates.split(' to ')[0]);
//   $('.spain .fianl_date').html(shippingDates.split(' to ')[1]);
// }, 500); // update every 5 seconds
//   } else if (country == 'ES') {
//     $('.product__icon__text.spain').show();
//     $('.product__block.shipping_date').show();
//     $('.product__icon__text.france').hide();
//     $('.product__icon__text.denmark').hide();
//     $('.product__icon__text.italy').hide();
//     function calculateShippingDates() {
//   const today = new Date();
//   const firstDate = new Date(today.getTime() + 24 * 60 * 60 * 1000); // add 1 day
//   const secondDate = new Date(today.getTime() + 5 * 24 * 60 * 60 * 1000); // add 5 days
//   // handle Sunday and Saturday
//   if (firstDate.getDay() === 0) {
//     firstDate.setDate(firstDate.getDate() + 1);
//   } else if (firstDate.getDay() === 6) {
//     firstDate.setDate(firstDate.getDate() + 2);
//   }
//   if (secondDate.getDay() === 0) {
//     secondDate.setDate(secondDate.getDate() + 1);
//   } else if (secondDate.getDay() === 6) {
//     secondDate.setDate(secondDate.getDate() + 2);
//   }
//   // format dates as "dd/mm"
//   const firstDateString = `${firstDate.getDate().toString().padStart(2, '0')}/${(firstDate.getMonth() + 1).toString().padStart(2, '0')}`;
//   const secondDateString = `${secondDate.getDate().toString().padStart(2, '0')}/${(secondDate.getMonth() + 1).toString().padStart(2, '0')}`;
//   return `${firstDateString} to ${secondDateString}`;
// }
// setInterval(() => {
//   const shippingDates = calculateShippingDates();
//   $('.spain .today_date').html(shippingDates.split(' to ')[0]);
//   $('.spain .fianl_date').html(shippingDates.split(' to ')[1]);
// }, 500); // update every 5 seconds
//   } else if (country == 'FR') {
//     $('.product__icon__text.spain').hide();
//      $('.product__block.shipping_date').show();
//     $('.product__icon__text.france').show();
//     $('.product__icon__text.denmark').hide();
//     $('.product__icon__text.italy').hide();
//       function calculateShippingDates() {
//   const today = new Date();
//   const firstDate = new Date(today.getTime() + 24 * 60 * 60 * 1000); // add 1 day
//   const secondDate = new Date(today.getTime() + 6 * 24 * 60 * 60 * 1000); // add 6 days
//   // handle Sunday and Saturday
//   if (firstDate.getDay() === 0) {
//     firstDate.setDate(firstDate.getDate() + 1);
//   } else if (firstDate.getDay() === 6) {
//     firstDate.setDate(firstDate.getDate() + 2);
//   }
//   if (secondDate.getDay() === 0) {
//     secondDate.setDate(secondDate.getDate() + 1);
//   } else if (secondDate.getDay() === 6) {
//     secondDate.setDate(secondDate.getDate() + 2);
//   }
//   // format dates as "dd/mm"
//   const firstDateString = `${firstDate.getDate().toString().padStart(2, '0')}/${(firstDate.getMonth() + 1).toString().padStart(2, '0')}`;
//   const secondDateString = `${secondDate.getDate().toString().padStart(2, '0')}/${(secondDate.getMonth() + 1).toString().padStart(2, '0')}`;
//   return `${firstDateString} to ${secondDateString}`;
// }
// setInterval(() => {
//   const shippingDates = calculateShippingDates();
//   $('.france .today_date').html(shippingDates.split(' to ')[0]);
//   $('.france .fianl_date').html(shippingDates.split(' to ')[1]);
// }, 500); // update every 5 seconds
//   } else if (country == 'DK') {
//     $('.product__icon__text.spain').hide();
//      $('.product__block.shipping_date').show();
//     $('.product__icon__text.france').hide();
//     $('.product__icon__text.denmark').show();
//     $('.product__icon__text.italy').hide();
//       function calculateShippingDates() {
//   const today = new Date();
//   const firstDate = new Date(today.getTime() + 24 * 60 * 60 * 1000); // add 1 day
//   const secondDate = new Date(today.getTime() + 6 * 24 * 60 * 60 * 1000); // add 6 days
//   // handle Sunday and Saturday
//   if (firstDate.getDay() === 0) {
//     firstDate.setDate(firstDate.getDate() + 1);
//   } else if (firstDate.getDay() === 6) {
//     firstDate.setDate(firstDate.getDate() + 2);
//   }
//   if (secondDate.getDay() === 0) {
//     secondDate.setDate(secondDate.getDate() + 1);
//   } else if (secondDate.getDay() === 6) {
//     secondDate.setDate(secondDate.getDate() + 2);
//   }
//   // format dates as "dd/mm"
//   const firstDateString = `${firstDate.getDate().toString().padStart(2, '0')}/${(firstDate.getMonth() + 1).toString().padStart(2, '0')}`;
//   const secondDateString = `${secondDate.getDate().toString().padStart(2, '0')}/${(secondDate.getMonth() + 1).toString().padStart(2, '0')}`;
//   return `${firstDateString} to ${secondDateString}`;
// }
// setInterval(() => {
//   const shippingDates = calculateShippingDates();
//   $('.denmark .today_date').html(shippingDates.split(' to ')[0]);
//   $('.denmark .fianl_date').html(shippingDates.split(' to ')[1]);
// }, 500); // update every 5 seconds
//   } else if (country == 'IT') {
//     $('.product__icon__text.spain').hide();
//      $('.product__block.shipping_date').show();
//     $('.product__icon__text.france').hide();
//     $('.product__icon__text.denmark').hide();
//     $('.product__icon__text.italy').show();
//   function calculateShippingDates() {
//   const today = new Date();
//   const firstDate = new Date(today.getTime() + 24 * 60 * 60 * 1000); // add 1 day
//   const secondDate = new Date(today.getTime() + 7 * 24 * 60 * 60 * 1000); // add 7 days
//   // handle Sunday and Saturday
//   if (firstDate.getDay() === 0) {
//     firstDate.setDate(firstDate.getDate() + 1);
//   } else if (firstDate.getDay() === 6) {
//     firstDate.setDate(firstDate.getDate() + 2);
//   }
//   if (secondDate.getDay() === 0) {
//     secondDate.setDate(secondDate.getDate() + 1);
//   } else if (secondDate.getDay() === 6) {
//     secondDate.setDate(secondDate.getDate() + 2);
//   }
//   // format dates as "dd/mm"
//   const firstDateString = `${firstDate.getDate().toString().padStart(2, '0')}/${(firstDate.getMonth() + 1).toString().padStart(2, '0')}`;
//   const secondDateString = `${secondDate.getDate().toString().padStart(2, '0')}/${(secondDate.getMonth() + 1).toString().padStart(2, '0')}`;
//   return `${firstDateString} to ${secondDateString}`;
// }
// setInterval(() => {
//   const shippingDates = calculateShippingDates();
//   $('.italy .today_date').html(shippingDates.split(' to ')[0]);
//   $('.italy .fianl_date').html(shippingDates.split(' to ')[1]);
// }, 500); // update every 5 seconds
//   } else (country == '') {
//     $('.product__icon__text.spain').show();
//      $('.product__block.shipping_date').show();
//     $('.product__icon__text.france').hide();
//     $('.product__icon__text.denmark').hide();
//     $('.product__icon__text.italy').hide();
//       function calculateShippingDates() {
//   const today = new Date();
//   const firstDate = new Date(today.getTime() + 24 * 60 * 60 * 1000); // add 1 day
//   const secondDate = new Date(today.getTime() + 5 * 24 * 60 * 60 * 1000); // add 5 days
//   // handle Sunday and Saturday
//   if (firstDate.getDay() === 0) {
//     firstDate.setDate(firstDate.getDate() + 1);
//   } else if (firstDate.getDay() === 6) {
//     firstDate.setDate(firstDate.getDate() + 2);
//   }
//   if (secondDate.getDay() === 0) {
//     secondDate.setDate(secondDate.getDate() + 1);
//   } else if (secondDate.getDay() === 6) {
//     secondDate.setDate(secondDate.getDate() + 2);
//   }
//   // format dates as "dd/mm"
//   const firstDateString = `${firstDate.getDate().toString().padStart(2, '0')}/${(firstDate.getMonth() + 1).toString().padStart(2, '0')}`;
//   const secondDateString = `${secondDate.getDate().toString().padStart(2, '0')}/${(secondDate.getMonth() + 1).toString().padStart(2, '0')}`;
//   return `${firstDateString} to ${secondDateString}`;
// }
// setInterval(() => {
//   const shippingDates = calculateShippingDates();
//   $('.spain .today_date').html(shippingDates.split(' to ')[0]);
//   $('.spain .fianl_date').html(shippingDates.split(' to ')[1]);
// }, 500); // update every 5 seconds
//   }
// }
// ========================================Show on all countries =============================
// document.addEventListener("DOMContentLoaded", (event) => {
//   $(".product__icon__text.spain").hide();
//   // $(".product__block.shipping_date").show();
//   $(".product__icon__text.france").hide();
//   $(".product__icon__text.denmark").hide();
//   $(".product__icon__text.italy").show();
//   function calculateShippingDates() {
//     const today = new Date();
//     const firstDate = new Date(today.getTime() + 24 * 60 * 60 * 1000); // add 1 day
//     const secondDate = new Date(today.getTime() + 7 * 24 * 60 * 60 * 1000); // add 7 days
//     // handle Sunday and Saturday
//     if (firstDate.getDay() === 0) {
//       firstDate.setDate(firstDate.getDate() + 1);
//     } else if (firstDate.getDay() === 6) {
//       firstDate.setDate(firstDate.getDate() + 2);
//     }
//     if (secondDate.getDay() === 0) {
//       secondDate.setDate(secondDate.getDate() + 1);
//     } else if (secondDate.getDay() === 6) {
//       secondDate.setDate(secondDate.getDate() + 2);
//     }
//     // format dates as "dd/mm"
//     const firstDateString = `${firstDate
//       .getDate()
//       .toString()
//       .padStart(2, "0")}/${(firstDate.getMonth() + 1)
//       .toString()
//       .padStart(2, "0")}`;
//     const secondDateString = `${secondDate
//       .getDate()
//       .toString()
//       .padStart(2, "0")}/${(secondDate.getMonth() + 1)
//       .toString()
//       .padStart(2, "0")}`;
//     return `${firstDateString} to ${secondDateString}`;
//   }
//   setInterval(() => {
//     const shippingDates = calculateShippingDates();
//     $(".italy .today_date").html(shippingDates.split(" to ")[0]);
//     $(".italy .fianl_date").html(shippingDates.split(" to ")[1]);
//   }, 500); // update every 5 seconds
// });

document.addEventListener("DOMContentLoaded", (event) => {
  // Hide elements
  // document
  //   .querySelectorAll(".product__icon__text.spain")
  //   .forEach((el) => (el.style.display = "none"));
  // document
  //   .querySelectorAll(".product__icon__text.france")
  //   .forEach((el) => (el.style.display = "none"));
  // document
  //   .querySelectorAll(".product__icon__text.denmark")
  //   .forEach((el) => (el.style.display = "none"));
  // document
  //   .querySelectorAll(".product__icon__text.italy")
  //   .forEach((el) => (el.style.display = "block"));

  function calculateShippingDates() {
    const today = new Date();
    const firstDate = new Date(today.getTime() + 9 * 24 * 60 * 60 * 1000); // add 1 day
    const secondDate = new Date(today.getTime() + 16 * 24 * 60 * 60 * 1000); // add 7 days

    // handle Sunday and Saturday
    if (firstDate.getDay() === 0) {
      firstDate.setDate(firstDate.getDate() + 1);
    } else if (firstDate.getDay() === 6) {
      firstDate.setDate(firstDate.getDate() + 2);
    }

    if (secondDate.getDay() === 0) {
      secondDate.setDate(secondDate.getDate() + 1);
    } else if (secondDate.getDay() === 6) {
      secondDate.setDate(secondDate.getDate() + 2);
    }

    // format dates as "dd/mm"
    const firstDateString = `${firstDate
      .getDate()
      .toString()
      .padStart(2, "0")}/${(firstDate.getMonth() + 1)
      .toString()
      .padStart(2, "0")}`;
    const secondDateString = `${secondDate
      .getDate()
      .toString()
      .padStart(2, "0")}/${(secondDate.getMonth() + 1)
      .toString()
      .padStart(2, "0")}`;
    return `${firstDateString} to ${secondDateString}`;
  }

  const shippingDates = calculateShippingDates();
  const dates = shippingDates.split(" to ");

  const newInStockText = `En stock, recibelo entre el <span class="today_date"> ${dates[0]} </span> y el <span class="fianl_date"> ${dates[1]}</span> `;

  if (document.querySelector(".variant__countdown--in")) {
    document.querySelector(".variant__countdown--in").innerHTML =
      newInStockText;
  }

  document
    .querySelectorAll(".italy .today_date")
    .forEach((el) => (el.innerHTML = dates[0]));
  document
    .querySelectorAll(".italy .fianl_date")
    .forEach((el) => (el.innerHTML = dates[1]));

  // setInterval(() => {
  //   const shippingDates = calculateShippingDates();
  //   const dates = shippingDates.split(" to ");
  //   document
  //     .querySelectorAll(".italy .today_date")
  //     .forEach((el) => (el.innerHTML = dates[0]));
  //   document
  //     .querySelectorAll(".italy .fianl_date")
  //     .forEach((el) => (el.innerHTML = dates[1]));
  // }, 5000); // update every 5 seconds
});
